/**
 * ShopSalesStatus Component
 * --
 * 작성자 - Owen
 * 작성일 - 2025 07 15 화요일
 * 마지막 수정일 - 2025 07 15 화요일
 */
import { Flex, Statistic } from 'antd';
import React from 'react';
import { stringToMoneyFormat } from 'utils';

const ShopSalesStatus = (props) => {
  /**
   * SECTION - Init
   */

  /**!SECTION - Init */

  /**
   * SECTION - Route
   */

  /**!SECTION - Route */

  /**
   * SECTION - Props
   */
  const {
    data = {
      delivery: [],
      subscription: [],
      rental: [],
      orders: [],
    },
  } = props;
  /**!SECTION - Props */

  /**
   * SECTION - Variable
   */
  const title = {
    totalAmount: { title: '오늘 총 매출' },
    totalNetAmount: { title: '오늘 순 매출' },
    totalRefundAmount: { title: '오늘 총 환불금액', color: '#EB2F96' },
    totalDiscountAmount: { title: '오늘 총 할인금액', color: '#EB2F96' },
  };
  /**!SECTION - Variable */

  /**
   * SECTION - State
   */

  /**!SECTION - State */

  /**
   * SECTION - Function
   */

  /**!SECTION - Function */

  /**
   * SECTION - Hooks
   */
  const Summary = React.useMemo(() => {
    const { delivery, subscription, rental, orders } = data;

    const newList = delivery.concat(subscription).concat(rental);

    // 총 배송비, 사용 포인트
    const totalShopOrderAmount = orders.reduce(
      (acc, cur) => {
        acc.totalDeliveryAmount += cur.final_delivery_price;
        acc.totalPointAmount += Math.abs(cur.use_point);
        return acc;
      },
      { totalDeliveryAmount: 0, totalPointAmount: 0 }
    );

    // Parcel, Rental별 결제금액, 할인금액, 환불금액 계산
    const summary = newList.reduce(
      (acc, cur) => {
        const { type, refund } = cur;

        if (refund) {
          acc.totalRefundAmount += refund.refund_amount;
        }

        if (type === 'DELIVERY' || type === 'STORE_PICKUP') {
          acc.totalPaymentAmount += cur.payment_price;
          acc.totalDiscountAmount += Math.abs(cur.discount_price ?? 0);
        } else if (type === 'SUBSCRIPTION') {
          acc.totalPaymentAmount += cur.regular_payment_info.price;
          acc.totalDiscountAmount +=
            cur.regular_payment_info.regular_payment_id === 1
              ? Math.abs(cur?.discount_price) ?? 0
              : Math.abs(cur?.regular_payment_info?.discount_price ?? 0);
        } else {
          acc.totalPaymentAmount += cur.rental_payment_info.price;
          acc.totalDiscountAmount +=
            cur.rental_payment_info.rental_payment_id === 1
              ? Math.abs(cur?.discount_price ?? 0)
              : Math.abs(cur?.rental_payment_info?.discount_price ?? 0);
        }

        return acc;
      },
      {
        totalRefundAmount: 0,
        totalDiscountAmount: 0,
        totalPaymentAmount: 0,
      }
    );

    return {
      totalAmount:
        summary.totalPaymentAmount +
        summary.totalDiscountAmount +
        totalShopOrderAmount.totalPointAmount +
        totalShopOrderAmount.totalDeliveryAmount,
      totalNetAmount:
        summary.totalPaymentAmount -
        summary.totalRefundAmount +
        totalShopOrderAmount.totalDeliveryAmount,
      totalRefundAmount: summary.totalRefundAmount,
      totalDiscountAmount:
        summary.totalDiscountAmount + totalShopOrderAmount.totalPointAmount,
    };
  }, [data]);
  /**!SECTION - Hooks */

  /**
   * SECTION - Render
   */
  return (
    <Flex gap={16}>
      {Object.entries(Summary).map(([key, value]) => (
        <div
          className="boxShadow"
          style={{
            background: '#FFFFFF',
            borderRadius: 4,
            padding: '16px 15px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flex: 1,
          }}
        >
          <Statistic
            className="cursorOverOpacity"
            direction={'row'}
            size="large"
            title={title[key].title}
            value={stringToMoneyFormat(value, '원')}
            valueStyle={{
              fontSize: '1.45em',
              color:
                value === '0' || value === 0
                  ? '#7f7f7f'
                  : title[key].color ?? '#1677ff',
            }}
          />
        </div>
      ))}
    </Flex>
  );
  /**!SECTION - Render */
};

export default ShopSalesStatus;
